import theme from 'config/theme';

export default {
  toolbar: {
    padding: '0!important',
    background: theme.palette.grays.lightBackgroundGray,
    borderRight: `1px solid ${theme.palette.grays.gray200}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderTop: `1px solid ${theme.palette.grays.gray200}`,
    position: 'fixed',
    bottom: '0',
    left: 0,
  },
};
